import { hasAcceptedAnalytics } from '../../../util/analyticsConsent';
import {
  applyGrantedGa4Loaders,
  initGA,
  isGa4Initialized,
  logPageView,
} from '../../../util/ga4ProfileAnalytics';

export { initGA, logPageView, isGa4Initialized };

/** @deprecated Prefer consent layer applyGrantedGa4Loaders; kept for tests and explicit refresh. */
export const refreshGa4FromConsent = () => {
  applyGrantedGa4Loaders(hasAcceptedAnalytics());
};
